import React from 'react';

import { Box, Typography } from '@mui/material';

interface Props {
  title: string;
}

export default function OpportunityHeaderTitle({ title }: Props) {
  return (
    <Box>
      <Typography variant="h5">{title}</Typography>
    </Box>
  );
}
